import { AbstractControl } from '@angular/forms'
import { Store } from '@ngrx/store'
import { map } from 'rxjs/operators'
import * as R from 'ramda'
import { selectAllRentals, Rental } from '../stores'
import { selectOnce } from '../rx-operators'

// @dynamic
export class RentalNameNotTakenValidator {
  static createValidator(store: Store<any>, rentalId?: string) {
    return (control: AbstractControl) => {
      return store.pipe(
        selectOnce(selectAllRentals),
        map((rentals) => {
          if (rentalId) {
            rentals = R.filter((r: Rental) => r.id !== rentalId, rentals || [])
          }
          const rental = R.find((r: Rental) => r.name === control.value)(rentals)
          return rental ? { nameTaken: true } : null
        })
      )
    }
  }
}
